import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  closing_year: yup.date().required(),
  month_start: yup.string().required(),
  month_end: yup.string().required(),
});
